<template>
	<div class="parent" style="height:calc(100vh - 50px);">
		<layout-3 :id=pageid1 :term=term :width=6 :height=1 style="max-height:30vh;"></layout-3>
		<hr style="margin-left:25px;margin-right:25px;"/>
		<div style="overflow-y:auto; margin-bottom:80px;">
			<layout-1 v-if="perms.includes('75')" :table_name="'Job Orders'" :id=pageid2 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'1'" :button_name="'Select'" :term=term></layout-1>
			<layout-1 v-if="perms.includes('74')" :table_name="'Invoices'" :id=pageid3 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'73'" :button_name="'Select'" :term=term></layout-1>
		</div>
		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('94')" v-on:click="button('Edit Number')">Edit</button>
				<button v-if="perms.includes('72')" v-on:click="button('Edit')">Edit PO Number Job Orders</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid1:PAGES.EDIT_PO_NUMBERS_PAGE,
			pageid2:PAGES.PO_JOBORDER_PAGE,
			pageid3:PAGES.PO_INVOICE_PAGE,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	methods:{
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid1,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_PO_Numbers.vue